export const GET_IMAGE = "@iweb/GET_IMAGE"
